import * as HELPER from "../../../src/config/helper";
import FullPageLoader from '@src/common/FullPageLoader';
import { useLanguage } from "../../../src/context/LanguageContext";
import { useState,useEffect } from "react";
import ConfirmPopup from '../../../src/common/ConfirmPopUp';
import {RemittanceDate} from '../../component/DatePicker';
import {RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES,REMITTANCE_TYPE,LEAD_ASSIGN_TO,ADMIN_OPS_STATUS,ADMIN_MAKER_STATUS,ADMIN_CHECKER_STATUS,ADMIN_CHECKER_COMPLETE_STATUS} from '../../../src/config/constant';
import moment from 'moment';
import { useParams } from "react-router-dom";
import { saveRemittanceDetails } from '../../../src/store/slices/remittance';
import PaymentInfo from "./PaymentInfoCard";

const InsurerPartnerRemittance = (props: any) => {
  const { id,type } = useParams<{ id: string,type:string }>()
  const { translations } = useLanguage();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [remittanceDetail , setRemittanceDetail] = useState<any>({});
  const [errors,SetErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [formChangeDetect, setFormChangeDetect] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState<string>(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
  const [confirmationFrom, setConfirmationFrom] = useState<string>("InsurerPartnerRemittance")
  const [LeadAssignTo, setLeadAssignTo] = useState<string>("");
  const [remittanceType, setRemittanceType] = useState<string>("");
  const [leadRemark, setLeadRemark] = useState<string>("");
  
  const handleSubmit = async () => {
      try{
        if(props.isMakerLoggedIn){
          // setViewPaymentInfo(false);
        }else{
          try{
            setLoading(true);
            let payload = {
              lead_id : id,
              amount : String(selectedFilters.amount_received_from_insurer),
              recieved_date : selectedFilters.amount_received_date_from_insurer,
              remittance_date : selectedFilters.date_of_remittance,
              type : REMITTANCE_TYPE['partner'],
               ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { mark_payment_complete: true }),
               ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status)) && { remarks: leadRemark })
            };
            const response:any = await saveRemittanceDetails(payload);
            if (response?.status === 200) {
              props.checkIfOpsIsLoggedIn();
              setFormChangeDetect(false);
              props.setCallReloadApi(props.callReloadApi+1);
              setShowConfirmation(false);
            }
          }catch (error) {
            console.error("Error while save Remittance Partner Detail:", error);
          }finally {
            setLoading(false);
          }
        }
      }catch (error) {
          console.error("Error while updating EMI detail:", error);
      }
  }

  const reloadDetail = async () => {
    props.setCallReloadApi(props.callReloadApi+1);
  }

  /**
   * Validate Partner Form
   * @returns 
   */
  const validateForm = () => {
    const newErrors: any = {};
    // Example validations
    // if (!selectedFilters?.date_of_remittance) {
    //   newErrors.date_of_remittance = "Date of Remittance is required";
    // }
    if (!selectedFilters?.amount_received_from_insurer) {
      newErrors.amount_received_from_insurer = "Amount received from insurer is required";
    } else if (isNaN(selectedFilters.amount_received_from_insurer)) {
      newErrors.amount_received_from_insurer = "Amount must be a number";
    }
    // if (!selectedFilters?.amount_received_date_from_insurer) {
    //   newErrors.amount_received_date_from_insurer = "Amount Received Date from Insurer is required";
    // }
    SetErrors(newErrors);
    // return true only if no errors
    return Object.keys(newErrors).length === 0;
  };

  /**
   * Handel to send to maker
   */
  const sendToMaker = async () => {
     try{
        if(props.isMakerLoggedIn || (props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status))){
          setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
          setConfirmationFrom("SendToMaker");
          setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
          setShowConfirmation(true);
        }else if (props.isCheckerLoggedIn || (props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status))) {
          setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
          setConfirmationFrom("SendToMaker");
          setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
          setShowConfirmation(true);
        }else{
          if(props.isOpsLoggedIn || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))){
            if(formChangeDetect){
              const isFormValid = validateForm();
              if(isFormValid){
                SetErrors({});
                setConfirmationMessage(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
                setConfirmationFrom("SaveDetail");
                setLeadAssignTo("");
                setShowConfirmation(true);
              }
            }else{
              setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
              setConfirmationFrom("SendToMaker");
              setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
              setShowConfirmation(true);
            }
          }
        }
      }catch (error) {
          console.error("Error while updating EMI detail:", error);
      }
  }

  // useEffect(() => {
  //     checkIfMakerIsLoggedIn();
  //     // eslint-disable-next-line
  // },[]);
  const cancelFormChange = async () => {
      setFormChangeDetect(false);
      props.setCallReloadApi(props.callReloadApi+1);
  }

   useEffect(() => {
    if (Array.isArray(props.remittanceDetails) && props.remittanceDetails.length > 0) {
      setRemittanceType(REMITTANCE_TYPE['partner']);
      const partnerRemittance = props.remittanceDetails.find((b: any) => b.remittance_type_name === REMITTANCE_TYPE['partner']);
      setRemittanceDetail(partnerRemittance);
      setSelectedFilters({
        ...selectedFilters,
        date_of_remittance: partnerRemittance.remittance_date ? moment(partnerRemittance.remittance_date).format('YYYY-MM-DD') : null,
        amount_received_from_insurer: partnerRemittance.amount_received_from_insurer,
        amount_received_date_from_insurer: partnerRemittance.amount_received_date_from_insurer ? moment(partnerRemittance.amount_received_date_from_insurer).format('YYYY-MM-DD') : null
      });
    }
    // eslint-disable-next-line
   },[props.remittanceDetails])

  const handleChange = (selectedValue: any, key: string) => {
    let value = selectedValue;
    if (key === 'amount_received_date_from_insurer' || key === 'date_of_remittance') {
      value = moment(selectedValue).format('YYYY-MM-DD');
    }
    if(key === "amount_received_from_insurer"){
      // Remove non-numeric chars except dot
      value = String(selectedValue).replace(/[^0-9.]/g, "");
      // Keep only first dot & max 4 decimals
      const match = value.match(RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES);
      value = match ? match[0] : "";
    }
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value,
    }));
    SetErrors((prev: any) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[key];
        return updatedErrors;
    });
    setFormChangeDetect(true);
  }

  const markPaymentComplete = () => {
    SetErrors({});
    setConfirmationMessage(translations.Remittance?.["COMPLETE_PAYMENT_CONFIRMATION"]);
    setConfirmationFrom("InsurerPartnerRemittance");
    setLeadAssignTo("");
    setShowConfirmation(true);
  }
  const validTypes = Object.values(REMITTANCE_TYPE);
  const currentType = validTypes.includes(type) ? type : null;
  const isPartnerDisabled = currentType !== REMITTANCE_TYPE.partner;
  return (
    <>
      <FullPageLoader show={loading} />
      {/* Insurer Partner Remittance */}
      <div className={`remittance-card`}>
        {
          isPartnerDisabled &&
          <div className="card-dissable"></div>
        }
        <div className="remittance-header">
          <h2>{translations.Remittance?.["INSURER_PARTNER_REMITTANCE"] || translations.commonMsg?.loading}</h2>
        </div>

        <div className="remittance-two-col">
          {/* Left Column */}
          <div className="remittance-col">
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["ACTUAL_REMITTANCE"] || translations.commonMsg?.loading}</span>
              <span>{`${HELPER.addCurrencyFormatting(Number(remittanceDetail?.actual_remittance || 0).toFixed(2))}`}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["PAID_DIRECTLY_TO_INSURER_BY_CUSTOMER"] || translations.commonMsg?.loading}</span>
              <span>{`${HELPER.addCurrencyFormatting(Number(remittanceDetail?.premium_paid || 0).toFixed(2))}`}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["AMOUNT_RECEIVED_FROM_INSURER"] || translations.commonMsg?.loading}</span>
              {/* HELPER.addCurrencyFormatting(selectedFilters?.amount_received_from_insurer || 0) */}
              <input
                type="text"
                className={
                  !props.isOpsLoggedIn && !props.isAdminLoggedIn
                    ? "input-bg-colur"
                    : (
                        // OPS condition
                        (props.isOpsLoggedIn &&
                          props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                          +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                        ||
                        // ADMIN condition (no roleStatus check)
                        (props.isAdminLoggedIn &&
                          ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                      )
                    ? ""
                    : "input-bg-colur"
                }
                value={
                  (
                    // OPS can edit
                    (props.isOpsLoggedIn &&
                      props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                      +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                    ||
                    // ADMIN can edit (status 1 or 2, no roleStatus check)
                    (props.isAdminLoggedIn &&
                      ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                  )
                    ? selectedFilters?.amount_received_from_insurer
                    : HELPER.addCurrencyFormatting(selectedFilters?.amount_received_from_insurer || 0)
                }
                onChange={(e) => handleChange(e.target.value, "amount_received_from_insurer")}
                readOnly={
                  !(
                    (props.isOpsLoggedIn &&
                      props.roleStatus?.includes(remittanceDetail?.remittance_status) &&
                      +remittanceDetail?.ops_id === +props.currentLoggedInUser)
                    ||
                    (props.isAdminLoggedIn &&
                      ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))
                  )
                }
              />
            </div>
            {errors?.amount_received_from_insurer && (
                <small className="error remittance-ml-auto">{errors?.amount_received_from_insurer}</small>
            )}
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["AMOUNT_RECEIVED_DATE_FROM_INSURER"] || translations.commonMsg?.loading}</span>
              {
                ((props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser) || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))) ?
                <RemittanceDate name="amount_received_date_from_insurer" maxDate={new Date()} selectedFilters={selectedFilters}  placeholder={translations.Remittance?.["AMOUNT_RECEIVED_DATE_FROM_INSURER"] || translations.commonMsg?.loading} handleChange={handleChange}/>
                :
                <input type="text" className={!props.isOpsLoggedIn  ? "input-bg-colur" : props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser ? "" : "input-bg-colur"} value={selectedFilters.amount_received_date_from_insurer ? moment(selectedFilters.amount_received_date_from_insurer).format("DD MMM, YYYY") : ''} readOnly />
              }
            </div>
              {errors?.amount_received_date_from_insurer && (
                  <small className="error remittance-ml-auto">{errors?.amount_received_date_from_insurer}</small>
              )}
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["FINAL_REMITTANCE_TO_INSURER"] || translations.commonMsg?.loading}</span>
              <span className="highlight-value">
                {HELPER.addCurrencyFormatting(
                  (
                    Number(remittanceDetail?.actual_remittance || 0) -
                    (
                      Number(remittanceDetail?.premium_paid || 0) +
                      Number(remittanceDetail?.amount_received_from_insurer || 0)
                    )
                  ).toFixed(2)
                )}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="remittance-col">
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["DATE_OF_REMITTANCE"] || translations.commonMsg?.loading}</span>
              {/* <input type="text" value="22 Jul, 2026" readOnly /> */}
              {
                ((props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser) || (props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status))) ?
                  <RemittanceDate name="date_of_remittance" maxDate={new Date()} selectedFilters={selectedFilters}  placeholder={translations.Remittance?.["DATE_OF_REMITTANCE"] || translations.commonMsg?.loading} handleChange={handleChange}/>
                :
                  <input type="text" className={!props.isOpsLoggedIn ? "input-bg-colur" : props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser ? "" : "input-bg-colur"} value={selectedFilters.date_of_remittance ? moment(selectedFilters.date_of_remittance).format("DD MMM, YYYY") : ''} readOnly />
              }
            </div>
              {errors?.date_of_remittance && (
                  <small className="error remittance-ml-auto">{errors?.date_of_remittance}</small>
              )}
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["BANK_NAME"] || translations.commonMsg?.loading}</span>
              <span className="bold-value">{remittanceDetail?.bank_name}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["BANK_ACCOUNT_NO"] || translations.commonMsg?.loading}</span>
              <span className="bold-value">{remittanceDetail?.account_number}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["ACCOUNT_NAME_BENEFICIARY_NAME"] || translations.commonMsg?.loading}</span>
              <span className="bold-value">{remittanceDetail?.beneficiary_name}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["BRANCH_NAME"] || translations.commonMsg?.loading}</span>
              <span className="bold-value">{remittanceDetail?.branch_name}</span>
            </div>
            <div className="remittance-row">
              <span className="remittance-row-heading">{translations.Remittance?.["PAYMENT_FROM"] || translations.commonMsg?.loading}</span>
              <span className="bold-value">{remittanceDetail?.payment_from || ''}</span>
            </div>
          </div>

        </div>
        {
          ((remittanceDetail?.payment && props.isCheckerLoggedIn && +remittanceDetail?.checker_id === +props.currentLoggedInUser) || (remittanceDetail?.payment && props.isAdminLoggedIn && ADMIN_CHECKER_COMPLETE_STATUS.includes(remittanceDetail?.remittance_status))) &&
          <PaymentInfo remittanceDetail={remittanceDetail}></PaymentInfo>
        }
        {
          currentType === REMITTANCE_TYPE.partner && 
          <>
            {
              props.isOpsLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.ops_id === +props.currentLoggedInUser &&
              <>
                <button className={`save-btn ${formChangeDetect ? "backtoopsbutoon" : ""}`} onClick={sendToMaker}>{translations.Remittance?.[!formChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}</button>
                {formChangeDetect && (
                  <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                )}
              </>
            }
            {
              props.isMakerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.maker_id === +props.currentLoggedInUser &&
              <div>
                <button className="save-btn backtoopsbutoon" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}</button>
                <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>{translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}</button>
              </div>
            }

            {
              props.isCheckerLoggedIn && props.roleStatus?.includes(remittanceDetail?.remittance_status) && +remittanceDetail?.checker_id === +props.currentLoggedInUser &&
              <div>
                <button className="save-btn backtoopsbutoon" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}</button>
                <button className="save-btn" onClick={markPaymentComplete}>{translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}</button>
              </div>
            }
            {/* ============================== */}
            {/* ADMIN-ONLY BUTTON CONDITIONS */}
            {/* ============================== */}
            {/* Admin sees OPS button when status is 1 or 2 */}
            {
              props.isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetail?.remittance_status) && (
                <>
                  <button className={`save-btn ${formChangeDetect ? "backtoopsbutoon" : ""}`} onClick={sendToMaker}>
                    {translations.Remittance?.[!formChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}
                  </button>
                  {formChangeDetect && (
                    <button className="cancle-btn" onClick={cancelFormChange}>{translations.Remittance?.CANCEL || "Cancel"}</button>
                  )}
                </>
              )
            }
            {/* Admin sees MAKER buttons when status is 3 or 4 */}
            {
              props.isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={sendToMaker}>
                    {translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={() => props.makePayment(remittanceType)}>
                    {translations.Remittance?.["MAKE_PAYMENT"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
            {/* Admin sees CHECKER buttons when status is 5 */}
            {
              props.isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetail?.remittance_status) && (
                <div>
                  <button className="save-btn backtoopsbutoon" onClick={sendToMaker}>
                    {translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}
                  </button>
                  <button className="save-btn" onClick={markPaymentComplete}>
                    {translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}
                  </button>
                </div>
              )
            }
          </>
        }
        {
          showConfirmation && 
          <ConfirmPopup
            confirmNo={() => setShowConfirmation(false)}
            confirmYes={handleSubmit}
            message={confirmationMessage}
            isConfirmNotVisible={true} 
            from={confirmationFrom}
            LeadAssignTo={LeadAssignTo}
            remittanceType={remittanceType}
            reloadDetail={reloadDetail}
            setLeadRemark={setLeadRemark}>
          </ConfirmPopup>
        }
      </div>
    </>
  );
};

export default InsurerPartnerRemittance;
